import React, { Component } from "react";
import ReactGA from "react-ga";

class App extends Component {
  componentDidMount() {
    //INFO : Google Analytics
    ReactGA.initialize("UA-145714156-4");
    ReactGA.pageview(window.location.pathname + window.location.search);

    //INFO : Navigator
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/windows phone/i.test(userAgent))
      window.alert(
        "Me Books App is not available on this device. Please use an Android or IOS device"
      );
    else if (/android/i.test(userAgent))
      window.location.href =
        "https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=co.mebooks.plus2";
    else if (/iPad|iPhone|iPod|AppleWebKit/.test(userAgent) && !window.MSStream)
      window.location = "https://apps.apple.com/us/app/id1638453374";
    else
      window.location.href =
        "https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=co.mebooks.plus2";
  }

  render() {
    return null;
  }
}

export default App;
